"use client";
import React, { useEffect, useState } from "react";
import CommonImage from "@/components/common/image/CommonImage";
import { useParams } from "next/navigation";
import HomePageService from "@/services/api/HomeService";

export default function StudentReviewDetails() {
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [studentReview, setStudentReview] = useState(false);

  const fetchStudentReview = async (ID) => {
    setLoading(true);
    try {
      const response = await HomePageService.getStudentReviewDetails(ID);
      console.log("response", response);
      setStudentReview(response);
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchStudentReview(params?.id);
  }, [params]);

  return (
    <section className="student-details_section section_padding">
      <div className="container">
        <div className="grid grid-cols-12">
          <div className="lg:col-span-8 col-span-12 lg:col-start-3">
            <div className="student-review-details">
              <div className="student-information">
                <CommonImage
                  src={studentReview?.image || "/images/home/student-image.png"}
                  className="student-image"
                  alt="Student Image"
                />

                <div className="name-title">
                  <h3 className="name">{studentReview?.name}</h3>
                  <p className="title">{studentReview?.relation} </p>
                </div>
              </div>
              <div className="details-textarea">
                <p>{studentReview?.description}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
